import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { globalTheme } from './theme'

const { name, theme } = globalTheme

export const vuetify = createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: name,
    themes: { [name]: theme }
  }
})
